import { PATTERNS } from '../../constants/validations';

export default phoneHome => !phoneHome || PATTERNS.PHONE_HOME.test(phoneHome);



// WEBPACK FOOTER //
// ./src/utils/validations/homePhoneValidator.js